import List from "./List";
import NavCategoryItems from "./NavCategoryItems";

const NavCategory = ({ dropdownData }) => {
  return (
    <List className="font-regular absolute top-9 left-[-25px] z-50 flex w-[367px] flex-col gap-y-3 bg-dropdownBg py-3 font-pop text-xs text-darkGreen">
      {dropdownData.map((item) => (
        <NavCategoryItems
          key={item.id}
          subCategories={item.subCategories}
          className="px-4"
          itemname={item.name}
          isArrow={true}
          title={item.subCategoryTitle || item.name}
        />
      ))}
    </List>
  );
};

export default NavCategory;
